import {
    LeverDefinition,
    LeasingSeasonConfig,
    LeverKey,
    TokenAllocations,
} from './types/leasingSeason.types'

export const LEVER_COLORS: Record<LeverKey, string> = {
    prospecting: '#6570E6',
    pipeline: '#547D7D',
    calls: '#E8A838',
    website: '#C45B7A',
}

export function defaultSeasonName(today = new Date()): string {
    return `${today.getFullYear() + 1} Leasing Season`
}

export const DEFAULT_SEASON_CONFIG: LeasingSeasonConfig = {
    name: defaultSeasonName(),
    startDate: '',
    endDate: '',
    goalPercent: 100,
    leaseTermId: null,
    renewalDeadline: null,
    renewalGoalPercent: null,
    allocations: {
        prospecting: 100,
        pipeline: 0,
        calls: 0,
        website: 0,
    },
}

export const DEFAULT_ALLOCATIONS: TokenAllocations = {
    ...DEFAULT_SEASON_CONFIG.allocations,
}

export const LEVERS: LeverDefinition[] = [
    {
        key: 'prospecting',
        label: 'Prospect data enriching',
        description:
            'Reveal email and phone for students at your served schools',
    },
    {
        key: 'pipeline',
        label: 'Pipeline Nurture',
        description: 'Move existing leads through application to lease',
        comingSoon: true,
    },
    {
        key: 'calls',
        label: 'AI Calls',
        description: 'Inbound call handling and outbound voice follow-ups',
        comingSoon: true,
    },
    {
        key: 'website',
        label: 'Website & Ads',
        description: 'Site optimization, SEO content, paid traffic',
        comingSoon: true,
    },
]
